import { render } from "./nowPlaying.vue?vue&type=template&id=c35cc120&scoped=true"
import script from "./nowPlaying.vue?vue&type=script&lang=js"
export * from "./nowPlaying.vue?vue&type=script&lang=js"

import "./nowPlaying.vue?vue&type=style&index=0&id=c35cc120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35cc120"]])

export default __exports__